import { CompositeTextInput, Popup } from '@leverege/ui-elements';
import React from 'react';
import I18N from '@leverege/i18n';
import { Toolbar } from '@leverege/ui-plugin';
import { ItemDelegate } from '@leverege/molten-core';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  tIcon
} = I18N.ns('molten.imagine.attributes.RelationshipTypeSelector');
const client = 'RelationshipTypeSelector';
export default class RelationshipTypeSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false
    };
  }
  onBottom = () => {
    const {
      nextToken
    } = this.props;
    if (nextToken) {
      this.loadData();
    }
  };
  onScroll = e => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      this.onBottom();
    }
  };
  onChangeFilter = (...args) => {
    const {
      onChangeFilter
    } = this.props;
    onChangeFilter(...args);
    this.setState({
      opened: true
    });
  };
  getContext() {
    const {
      attribute,
      search
    } = this.props;
    return {
      attribute,
      isScannable: attribute.source?.attribute?.getTagStartingWith('scannable:', true),
      search,
      onSearchChange: this.onChangeFilter,
      clientProps: {
        objectType: attribute.source?.attribute?.targetBlueprint?.type
      }
    };
  }
  renderTarget = ({
    ref
  }) => {
    const {
      attribute,
      value,
      onChangeFilter,
      search,
      nameAttribute
    } = this.props;
    const item = ItemDelegate.getItem(value);
    const name = nameAttribute.get(item);
    return /*#__PURE__*/_jsx(CompositeTextInput, {
      variant: "mobileSearch",
      domRef: ref,
      hint: name,
      icon: tIcon('search'),
      onDoubleClick: evt => {
        evt.stopPropagation();
      },
      onFocus: () => this.setState({
        opened: true
      }),
      onBlur: () => {
        setTimeout(() => {
          this.setState({
            opened: false
          });
        }, 250);
      },
      changeOnReturn: false,
      alwaysFireOnReturn: false,
      onChange: onChangeFilter,
      value: search,
      post: /*#__PURE__*/_jsx(Toolbar, {
        variant: "actionBar",
        prefer: "icon",
        context: this.getContext(),
        matchContext: {
          client,
          objectType: attribute.objectType
        }
      })
    });
  };
  render() {
    const {
      variant,
      values,
      value,
      eventData,
      onChange
    } = this.props;
    const {
      opened
    } = this.state;
    return /*#__PURE__*/_jsx(Popup, {
      setPopupMinWidth: true,
      onScroll: this.onScroll,
      variant: variant,
      trigger: this.renderTarget,
      opened: opened,
      children: values.map(val => {
        return /*#__PURE__*/_jsx(Popup.Item, {
          onClick: onChange,
          eventData: eventData,
          value: val.value,
          checkStyle: "radio",
          checked: val.value === value,
          children: val.name
        }, val.value);
      })
    });
  }
}